import { motion } from "framer-motion";
import AnimatedCounter from "./AnimatedCounter";
import { STATS } from "../data/siteContent";

export default function Stats() {
  return (
    <section className="relative overflow-hidden border-y border-white/10 bg-gradient-to-r from-accent/15 via-ink to-coral/10 py-20">
      <div className="absolute inset-0 bg-diagonal-stripe opacity-30" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 sm:grid-cols-2 lg:grid-cols-4 sm:px-6 lg:px-8">
        {STATS.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="text-center"
          >
            <p className="font-sans text-4xl font-semibold text-white sm:text-5xl">
              <AnimatedCounter value={stat.value} suffix={stat.suffix} />
            </p>
            <p className="mt-3 font-mono text-[11px] font-medium uppercase tracking-corporate text-white/50">
              {stat.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
